import { pick } from 'ramda';

import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../actionTypes';

const initialState = [];

const fetchLockersError = () => [];

const fetchLockersSuccess = (_, { payload }) => payload.lockers.map(locker => pick(['id', 'appointments'], locker));

const fetchLockerSuccess = (_, { payload }) => [pick(['id', 'appointments'], payload.locker ?? {})];

export default createReducer(initialState, {
  [actionTypes.GET_LOCKER_CALENDAR_ERROR]: fetchLockersError,
  [actionTypes.GET_LOCKERS_CALENDAR_ERROR]: fetchLockersError,
  [actionTypes.GET_LOCKER_CALENDAR_SUCCESS]: fetchLockerSuccess,
  [actionTypes.GET_LOCKERS_CALENDAR_SUCCESS]: fetchLockersSuccess,
});
